import { AxiosResponse } from "axios";
import { axiosInstance } from "../../Authentication/AxiosInterceptor";
import { AreaDisplayInfo } from "../../Types/AreaDisplayInfo/AreaDisplayInfo";
import { PagedResponse } from "../../Types/Paging/PagedResponse";
import { IProductQuestionnaire } from "../../Types/Products/IProductQuestionnaire";
import { PagedRequest } from "../../Types/Paging/PagedRequest";
import { IDynamicFieldPrototype, IDynamicField, FieldType, SpecialField } from "../../Types/Products/IDynamicField";
import { IQuestionnaireSection } from "../../Types/Products/IQuestionnaireSection";
import { ICriteriaBankItem } from "../../Types/TemplateBank/ICriteriaBankItem";
import { ICriteriaItem } from "../../Types/Products/ICriteriaItemData";
import { IQuestionnaireQuestion } from "../../Types/Products/IQuestionnaireQuestion";
import { CreateQuestionRequest, DeleteQuestionsRequest } from "../../Types/TemplateBank/CreateQuestionRequest";
import { ReorderQuestionRequest } from "../../Types/TemplateBank/ReorderQuestionRequest";
import { ImportTemplateRequest } from "../../Types/Evaluate/ImportTemplateRequest";
import { IDropDownListItem } from "../../Types/DropDownList/IDropDownListItem";
import { ProductType } from "../../Types/ProductType";


export async function ImportQuestionnaireTemplate(templateId: string, clientId: string, departmentId?: string, partnerId?: string, groupIds?: string[], observee?: string): Promise<IProductQuestionnaire>{

    try {
        const response: AxiosResponse<IProductQuestionnaire> = await axiosInstance.post("ImportQuestionnaireTemplate", {
            templateId: templateId,
            departmentId: departmentId,
            partnerId: partnerId,
            groupIds: groupIds,
            clientId: clientId,
            observee: observee
        } as ImportTemplateRequest);

        return response.data;
       
      } catch (error) {
        console.log(error);
        throw error;
      }
}

export async function GetPagedQuestionnaireTemplates(request: PagedRequest): Promise<PagedResponse<AreaDisplayInfo>>{

  try {
      const response: AxiosResponse<PagedResponse<AreaDisplayInfo>> = await axiosInstance.put(`GetPagedQuestionnaireTemplates`, request);
  
      return response.data;
     
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function GetPagedArchivedQuestionnaireTemplates(request: PagedRequest): Promise<PagedResponse<AreaDisplayInfo>>{

  try {
      const response: AxiosResponse<PagedResponse<AreaDisplayInfo>> = await axiosInstance.put(`GetPagedArchivedQuestionnaireTemplates`, request);
  
      return response.data;
     
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function UpdateQuestionnaireTemplateTitle(templateId: string, title: string, clientId: string) {

  try {
      const response: AxiosResponse = await axiosInstance.post(`UpdateQuestionnaireTemplateTitle/${templateId}/${clientId}`, title);

    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function ToggleQuestionnaireTemplateArchivedById(templateId: string, clientId: string) {

  try {
      const response: AxiosResponse = await axiosInstance.get(`ToggleQuestionnaireTemplateArchivedById/${templateId}/${clientId}`);
     
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateFieldPrototype(title: string, type: FieldType, templateId: string, specialField: SpecialField, clientId: string): Promise<IDynamicFieldPrototype>{

  try {
    const response: AxiosResponse<IDynamicFieldPrototype> = await axiosInstance.post(`CreateFieldPrototype`, {
      templateId: templateId,
      fieldTitle: title,
      fieldType: type,
      specialField: specialField,
      clientId: clientId
    });
    return response.data;
  
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function UpdateFieldPrototype(data: IDynamicFieldPrototype, clientId: string){

  try {
    const response: AxiosResponse = await axiosInstance.post(`UpdateFieldPrototype/${clientId}`, data);
    return response.data;
  
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function UpdateActivityField(data: IDynamicField){

  try {
    const response: AxiosResponse = await axiosInstance.post(`UpdateActivityField`, data);
    return response.data;
  
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function DeleteFieldPrototypesByIdList(fieldIds: string[]){

  try {
    const response: AxiosResponse = await axiosInstance.post(`DeleteFieldPrototypesByIdList`, fieldIds);
  
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function GetFieldPrototypesByTemplateId(templateId: string, clientId: string): Promise<IDynamicFieldPrototype[]>{

  try {
    var response: AxiosResponse<IDynamicFieldPrototype[]> = await axiosInstance.get(`GetFieldPrototypesByTemplateId/${templateId}/${clientId}`);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateQuestionnaireTemplateByTitle(title: string, clientId: string, productType: ProductType): Promise<string>{

  try {
    var response: AxiosResponse<string> = await axiosInstance.post(`CreateQuestionnaireTemplateByTitle/${clientId}/${productType}`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateClientQuestionnaireTemplateByTitle(title: string, clientId: string, productType: ProductType): Promise<string>{

  try {
    var response: AxiosResponse<string> = await axiosInstance.post(`CreateClientQuestionnaireTemplateByTitle/${clientId}/${productType}`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateImproveTemplateByTitle(title: string, clientId: string): Promise<string>{

  try {
    var response: AxiosResponse<string> = await axiosInstance.post(`Improve/CreateTemplateByTitle`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateDevelopTemplateByTitle(title: string, clientId: string): Promise<string>{

  try {
    var response: AxiosResponse<string> = await axiosInstance.post(`Develop/CreateTemplateByTitle`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateClientTemplateByTitle(title: string, clientId: string): Promise<string>{

  try {
    var response: AxiosResponse<string> = await axiosInstance.post(`Improve/CreateClientTemplateByTitle/${clientId}`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateClientDevelopTemplateByTitle(title: string, clientId: string): Promise<string>{

  try {
    var response: AxiosResponse<string> = await axiosInstance.post(`Develop/CreateClientTemplateByTitle/${clientId}`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateSectionByQuestionnaireTemplateId(templateId: string, title: string, clientId: string): Promise<IQuestionnaireSection>{

  try {
       var response: AxiosResponse<IQuestionnaireSection> = await axiosInstance.post(`CreateSectionByQuestionnaireTemplateId/${templateId}/${clientId}`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateCriteriaByQuestionnaireTemplateIdAndSectionIdAndTitle(templateId: string, sectionId: string, title: string, clientId: string): Promise<ICriteriaItem>{

  try {
       var response: AxiosResponse<ICriteriaItem> = await axiosInstance.post(`CreateCriteriaByQuestionnaireTemplateIdAndSectionIdAndTitle/${templateId}/${sectionId}/${clientId}`, title);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function UpdateSectionTitleById(title: string, sectionId: string){

  try {
    const response: AxiosResponse = await axiosInstance.post(`UpdateSectionTitleById/${sectionId}`, title);
    //return response.data;
  
    } catch (error) {
      console.log(error);
      throw error;
    }
}

//Protected By AddEditRemoveTemplates
export async function UpdateCriteriaTitleById(title: string, criteriaId: string, clientId: string){

  try {
    const response: AxiosResponse = await axiosInstance.post(`UpdateCriteriaTitleById/${criteriaId}/${clientId}`, title);
    //return response.data;
  
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export type DevelopTemplateSettings = {
  personShown: boolean;
  picklistShown: boolean;
  dropdownShown: boolean;
  personName: string;
  picklistName: string;
  dropdownName: string;
  picklistOptions: string[];
  dropdownOptions: string[];
};

export async function GetDevelopTemplateSettings(templateId: string, clientId: string): Promise<DevelopTemplateSettings> {
  try {
    const response: AxiosResponse<DevelopTemplateSettings> = await axiosInstance.get(`GetDevelopTemplateSettings/${templateId}/${clientId}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function UpdateDevelopTemplateSettings(
  templateId: string,
  clientId: string,
  settings: DevelopTemplateSettings
): Promise<void> {
  try {
    await axiosInstance.post(`UpdateDevelopTemplateSettings/${templateId}/${clientId}`, settings);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

//Protected By AddEditRemoveTemplates
export async function GetSectionsByTemplateId(templateId: string, clientId: string): Promise<IQuestionnaireSection[]>{

  try {
    var response: AxiosResponse<IQuestionnaireSection[]> = await axiosInstance.get(`GetSectionsByTemplateId/${templateId}/${clientId}`);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function DeleteSectionsAndCriteriaByTemplateId(templateId: string, itemIds: string[], clientId: string){

  try {
    const response: AxiosResponse = await axiosInstance.post(`DeleteSectionsAndCriteriaByTemplateId/${templateId}/${clientId}`, itemIds);
  
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function GetQuestionsByTemplateIdAndCriteriaId(templateId: string, criteriaId: string, clientId: string): Promise<IQuestionnaireQuestion[]>{

  try {
    var response: AxiosResponse<IQuestionnaireQuestion[]> = await axiosInstance.get(`GetQuestionsByTemplateIdAndCriteriaId/${templateId}/${criteriaId}/${clientId}`);
       return response.data;
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function CreateQuestionInQuestionnaireTemplate(templateId: string, sectionId: string, criteriaId: string, questionText: string, clientId: string): Promise<IQuestionnaireQuestion>{

  try {
    const response: AxiosResponse<IQuestionnaireQuestion> = await axiosInstance.post('CreateQuestionInQuestionnaireTemplate', {  
      templateId: templateId,  
      sectionId: sectionId,  
      criteriaId: criteriaId,  
      questionText: questionText,
      clientId: clientId 
  } as CreateQuestionRequest);  
    
  return response.data;  
  
    
    } catch (error) {
      console.log(error);
      throw error;
    }
}

export async function DeleteQuestionsInCriteriaTemplate(templateId: string, sectionId: string, criteriaId: string, questionIds: string[], clientId: string): Promise<void> {  
  try {  
    const requestBody: DeleteQuestionsRequest = {  
      templateId: templateId,  
      sectionId: sectionId,  
      criteriaId: criteriaId,  
      questionIds: questionIds,
      clientId: clientId
    };  
  
    const response: AxiosResponse = await axiosInstance.post('DeleteQuestionsInCriteriaTemplate', requestBody);  
    console.log('Delete questions response:', response);  
  } catch (error) {  
    console.error('Error deleting questions:', error);  
    throw error;  
  }  
}

export async function ReorderQuestionInCriteriaTemplate(templateId: string, sectionId: string, criteriaId: string, questionId: string, direction: 'up' | 'down', clientId: string): Promise<IQuestionnaireQuestion[]> {
  try {
    const requestBody: ReorderQuestionRequest = {
      templateId: templateId,
      sectionId: sectionId,
      criteriaId: criteriaId,
      questionId: questionId,
      direction: direction,
      clientId: clientId
    };

    const response: AxiosResponse<IQuestionnaireQuestion[]> = await axiosInstance.post('ReorderQuestionInCriteriaTemplate', requestBody);
    return response.data;
  } catch (error) {
    console.error('Error reordering question:', error);
    throw error;
  }
}

export async function ReorderSectionInTemplate(templateId: string, sectionId: string, direction: 'up' | 'down', clientId: string): Promise<IQuestionnaireSection[]> {
  try {
    const requestBody = {
      templateId: templateId,
      sectionId: sectionId,
      direction: direction,
      clientId: clientId
    };

    const response: AxiosResponse<IQuestionnaireSection[]> = await axiosInstance.post('ReorderSectionInTemplate', requestBody);
    return response.data;
  } catch (error) {
    console.error('Error reordering section:', error);
    throw error;
  }
}

export async function ReorderCriteriaInSection(templateId: string, sectionId: string, criteriaId: string, direction: 'up' | 'down', clientId: string): Promise<IQuestionnaireSection[]> {
  try {
    const requestBody = {
      templateId: templateId,
      sectionId: sectionId,
      criteriaId: criteriaId,
      direction: direction,
      clientId: clientId
    };

    const response: AxiosResponse<IQuestionnaireSection[]> = await axiosInstance.post('ReorderCriteriaInSection', requestBody);
    return response.data;
  } catch (error) {
    console.error('Error reordering criteria:', error);
    throw error;
  }
}

export async function ReorderFieldInTemplate(templateId: string, fieldId: string, direction: 'up' | 'down', clientId: string): Promise<IDynamicFieldPrototype[]> {
  try {
    const requestBody = {
      templateId: templateId,
      fieldId: fieldId,
      direction: direction,
      clientId: clientId
    };

    const response: AxiosResponse<IDynamicFieldPrototype[]> = await axiosInstance.post('ReorderFieldInTemplate', requestBody);
    return response.data;
  } catch (error) {
    console.error('Error reordering field:', error);
    throw error;
  }
}  

export async function CompleteQuestionnaireTemplateById(templateId: string, clientId: string): Promise<void> {  
  try {  
    const response: AxiosResponse = await axiosInstance.put(`CompleteQuestionnaireTemplateById/${templateId}/${clientId}`);  

  } catch (error) {  
    console.error('Error deleting questions:', error);  
    throw error;  
  }  
}

export async function CompleteTemplateWithoutMandate(templateId: string, clientId: string): Promise<void> {  
  try {  
    const response: AxiosResponse = await axiosInstance.put(`CompleteTemplateWithoutMandate/${templateId}/${clientId}`);  

  } catch (error) {  
    console.error('Error completing template without mandate:', error);  
    throw error;  
  }  
}

export async function ToggleTemplateDisabledStatus(templateId: string, clientId: string): Promise<boolean> {
  try {
    const response: AxiosResponse<boolean> = await axiosInstance.post(`ToggleTemplateDisabledStatus/${templateId}/${clientId}`);
    return response.data;
  } catch (error) {
    console.error('Error toggling template disabled status:', error);
    throw error;
  }
}

export async function GetMandatedTemplatesDisplayInfoByClient(clientId: string, archived?: boolean): Promise<AreaDisplayInfo[]> {
  try {
    const url = archived !== undefined
      ? `GetMandatedTemplatesDisplayInfoByClient/${clientId}?archived=${archived}`
      : `GetMandatedTemplatesDisplayInfoByClient/${clientId}`;

    const response: AxiosResponse<AreaDisplayInfo[]> = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching mandated templates display info by client ID:', error);
    throw error;
  }
}

export async function GetMesmaTemplatesDisplayInfoByClient(clientId: string, archived?: boolean): Promise<AreaDisplayInfo[]> {
  try {
    const url = archived !== undefined
      ? `GetMesmaTemplatesDisplayInfoByClient/${clientId}?archived=${archived}`
      : `GetMesmaTemplatesDisplayInfoByClient/${clientId}`;

    const response: AxiosResponse<AreaDisplayInfo[]> = await axiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching Mesma templates display info by client ID:', error);
    throw error;
  }
}

export async function GetMandatedMesmaTemplatesDisplayInfos(clientId: string): Promise<AreaDisplayInfo[]> {
  try {
    const response: AxiosResponse<AreaDisplayInfo[]> = await axiosInstance.get(`GetMandatedMesmaTemplates/${clientId}`);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching mandated Mesma templates:', error);
    throw error;
  }
}

export async function GetMandatedMesmaTemplates(clientId: string): Promise<IDropDownListItem[]> {
  try {
    const response: AxiosResponse<AreaDisplayInfo[]> = await axiosInstance.get(`GetMandatedMesmaTemplates/${clientId}`);
    return response.data.map(template => ({
      text: template.title,
      value: template.id,
      colour: undefined,
      textColour: undefined
    }));
  } catch (error: any) {
    console.error('Error fetching mandated Mesma templates:', error);
    throw error;
  }
}

export async function CreateTemplateFromMesmaTemplate(
  mesmaTemplateId: string, 
  newTitle: string, 
  clientId: string
): Promise<string> {
  try {
    const response: AxiosResponse<string> = await axiosInstance.post("CreateTemplateFromMesmaTemplate", {
      mesmaTemplateId,
      newTitle, 
      clientId
    });
    return response.data;
  } catch (error: any) {
    console.error('Error creating template from Mesma template:', error);
    throw error;
  }
}  